import React from 'react';
import MuiTypography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

const StyledTypography = withStyles({
    root: {
        fontWeight: '600'
    }
})(MuiTypography);

const TypographyNavLink = props => <StyledTypography {...props} />;

export { TypographyNavLink };
export default TypographyNavLink;
